/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { InformationModule } from '@coursera-web/cds-labs';

import { Typography2 } from '@coursera/cds-core';

import CTAContentful from 'bundles/coursera-plus-landing-page/components/ctaContentful/CTAContentful';
import { CTA_LOCATIONS } from 'bundles/coursera-plus-landing-page/contentful/constants';
import { useLandingPageExtended } from 'bundles/coursera-plus-landing-page/contentfulData/useLandingPageData';

import learnerStatsImage from 'images/coursera-plus/learner-statistics.png';

import _t from 'i18n!nls/coursera-plus-landing-page';

type ImageType = React.ComponentProps<typeof InformationModule>['image'];

const styles = {
  title: css`
    margin-bottom: var(--cds-spacing-300);
  `,
};

const LEARNER_STATS_IMAGE_DIMENSIONS = {
  width: 541,
  height: 379,
};

const LearnerStatisticsModule = () => {
  const landingPageExtended = useLandingPageExtended();
  const moduleImage: ImageType = {
    url: learnerStatsImage,
    ...LEARNER_STATS_IMAGE_DIMENSIONS,
  };
  const ctaPieces = landingPageExtended.landingPage.heroCtaPartsCollection?.items.filter((ctaPart) =>
    ctaPart?.presentation?.toLowerCase().includes('button')
  );

  const description = (
    <>
      <Typography2 variant="titleMedium" component="h2" color="inherit" css={styles.title}>
        {_t(
          '77% of learners report career benefits, like landing a new job, earning a promotion, gaining applicable skills, and more.¹'
        )}
      </Typography2>
      <CTAContentful ctaPieces={ctaPieces} ctaLocation={CTA_LOCATIONS.learnerStats} />
    </>
  );

  return <InformationModule image={moduleImage} layout="text7/image5" description={description} />;
};

export default LearnerStatisticsModule;
